import React, { useRef } from "react";
import DownloadExcel from "../../../../Extra/DownloadExcel";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import TooltipHeader from "../../../../Extra/TooltipHeader";
const Report02 = ({ data, a, globalDate }) => {
  const tableRef = useRef();
  const sum = (column) => {
    return a?.reduce((s, o) => s + Number(o[column] || 0), 0);
  };

  return (
    <div className="">
      <h6 className="p-2 bg-dark text-white">PUNCTUALITY PERFORMANCE REPORT</h6>

      {data.length > 0 ? (
        <div
          className="table-responsive table-wrapper"
          s
          style={{ maxHeight: "650px" }}
        >
          <table
            ref={tableRef}
            className="table newUiTable table-hover table-striped "
            style={{ fontSize: "11px" }}
          >
            <thead className="" style={{ zIndex: 1 }}>
              <tr className="p-0 m-0">
                <th>SR NO. </th>
                <th>DATE</th>
                {/* <OverlayTrigger
                      placement="top"
                      delay={{ show: 100, hide: 200 }}
                      overlay={<Tooltip id={`tooltip-1`}>Station</Tooltip>}
                    >
                      <th>JBP</th>
                    </OverlayTrigger> */}
                <TooltipHeader
                  id={`tooltip-1`}
                  label="GT"
                  tooltip="GROUP TYPE"
                />
                {/* <OverlayTrigger
                      placement="top"
                      delay={{ show: 100, hide: 200 }}
                      overlay={<Tooltip id={`tooltip-2`}>Scheduled</Tooltip>}
                    >
                      <th>Sch</th>
                    </OverlayTrigger> */}
                <TooltipHeader
                  id={`tooltip-2`}
                  label="Sch"
                  tooltip="Scheduled"
                />
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 100, hide: 200 }}
                  overlay={<Tooltip id={`tooltip-3`}>Reported</Tooltip>}
                >
                  <th>RPT</th>
                </OverlayTrigger>
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 100, hide: 200 }}
                  overlay={<Tooltip id={`tooltip-4`}>Before time</Tooltip>}
                >
                  <th>BT</th>
                </OverlayTrigger>
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 100, hide: 200 }}
                  overlay={<Tooltip id={`tooltip-4`}>Right time</Tooltip>}
                >
                  <th>RT</th>
                </OverlayTrigger>
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 100, hide: 200 }}
                  overlay={<Tooltip id={`tooltip-5`}>Mackup</Tooltip>}
                >
                  <th>MKUP</th>
                </OverlayTrigger>
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 100, hide: 200 }}
                  overlay={<Tooltip id={`tooltip-6`}>Not late/lost</Tooltip>}
                >
                  <th>NLT</th>
                </OverlayTrigger>
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 100, hide: 200 }}
                  overlay={<Tooltip id={`tooltip-7`}>Late/ Lost Train</Tooltip>}
                >
                  <th>LT</th>
                </OverlayTrigger>
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 100, hide: 200 }}
                  overlay={<Tooltip id={`tooltip-8`}>TODAY</Tooltip>}
                >
                  <th>TD</th>
                </OverlayTrigger>
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 100, hide: 200 }}
                  overlay={<Tooltip id={`tooltip-9`}>MONTH</Tooltip>}
                >
                  <th>M</th>
                </OverlayTrigger>
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 100, hide: 200 }}
                  overlay={<Tooltip id={`tooltip-10`}>YEAR</Tooltip>}
                >
                  <th>Y</th>
                </OverlayTrigger>
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 100, hide: 200 }}
                  overlay={<Tooltip id={`tooltip-11`}>TODAY LAST YEAR</Tooltip>}
                >
                  <th>TD-LY</th>
                </OverlayTrigger>
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 100, hide: 200 }}
                  overlay={<Tooltip id={`tooltip-12`}>LAST YEAR</Tooltip>}
                >
                  <th>LY</th>
                </OverlayTrigger>
                {/* <th >JBP</th>
                  <th >Sch</th>
                  <th >RPT</th>
                  <th >BT</th>
                  <th >RT</th>
                  <th >MKUP</th>
                  <th >NLT</th>
                  <th >LT</th>
                  {/* <th >ZoneL Loss</th> */}
                {/* <th >TODAY</th>
                  <th >MONTH</th>
                  <th >YEAR</th>
                  <th >TODAY_LY</th>
                  <th >LY</th>  */}
              </tr>

              {/* <tr>
                <th>SR NO. </th>
                <th>DATE</th>
                <th>GROUP_TYPE</th>
                <th>SCH</th>
                <th>RPT</th>
                <th>BT</th>
                <th>RT</th>
                <th>MKUP</th>
                <th>ULT</th>
                <th>LT</th>
                <th>TD</th>
                <th>M</th>
                <th>Y</th>
                <th>TD-LY</th>
                <th>LY</th>
              </tr> */}
            </thead>
            <tbody>
              {a &&
                a.map((o, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td> <td>{globalDate?.slice(0, 10)}</td>
                    <td>
                      {o.group_type
                        .replace("totalM", "MEXP")
                        .replace("totalP", "TOTAL")
                        .replace("MPSO", " ")}{" "}
                      {o.train_type.replace("PAS", "PASS")}
                    </td>{" "}
                    <td>{o?.SCH}</td>
                    <td>{o?.RPT}</td> <td>{o?.BT}</td> <td>{o?.RT}</td>{" "}
                    <td>{o?.MKUP}</td> <td>{o?.NLT}</td> <td>{o?.LT}</td>{" "}
                    <td>{o?.PP_CFY_DAY}</td> <td>{o?.PP_CFY_MONTH}</td>{" "}
                    <td>{o?.PP_CFY}</td> <td>{o?.PP_LFY_DAY}</td>{" "}
                    <td>{o?.PP_LFY}</td>
                  </tr>
                ))}
            </tbody>
            <tfoot>
              <tr className="table-dark fw-bold">
                <td colSpan={3}>Total</td>
                <td>{sum("SCH")}</td>
                <td>{sum("RPT")}</td>
                <td>{sum("BT")}</td> <td>{sum("RT")}</td>
                <td>{sum("MKUP")}</td> <td>{sum("NLT")}</td>
                <td>{sum("LT")}</td> <td colSpan={5}></td>
              </tr>
            </tfoot>
          </table>{" "}
          <DownloadExcel
            tableRef={tableRef}
            fileName={`PUNCTUALITY PERFORMANCE - ${globalDate}  }`}
          />
        </div>
      ) : (
        <div className="bg-dark text-danger p-3">No Data Found</div>
      )}
    </div>
  );
};
export default Report02;
